import { AdaRedirectButton, BreadcrumbItem, FormattedDate, useFeatureToggle } from '@css-xp/base';
//@ts-ignore
import RefundIcon from '@css-xp/base/assets/img/icon-refund.svg';
import { BillingDoc, Refund } from '@atlassian/cssxp-types-billing';
import { Organization } from '@atlassian/cssxp-types-organization';
import { DOMAIN_PATH, INVOICE_PATH, ORGANIZATION_PATH, REFUND_PATH, SourceSystem } from '@atlassian/cssxp-typescommon';
import { ENABLE_CREDIT_NOTES_TRANSACTION_ACCOUNT } from '@atlassian/cssxp-utils-generic';
import isEmpty from 'lodash/isEmpty';
import memoize from 'lodash/memoize';
import * as React from 'react';
import { InvoiceRefundStatusLozenge } from '../../invoices';
import { InvoiceRefundCreditNote } from '../../invoices/src/components/invoice-refund-creditnote-lozenge';

/**
 * Returns the URL by memorizing the url as per id as base URL will be constant
 */
export const getViewInAdaRefundUrl = memoize(
  (baseUrl?: string, id?: string) => {
    if (id && baseUrl) {
      const idNumber = id.startsWith('RF-') ? id.slice(3) : id;
      return `${baseUrl}/ViewRefund.jspa?refundId=${encodeURIComponent(idNumber)}`;
    }
    return '';
  },
  (...arg) => arg[1]
);

export const getRefundSubheader = (refund?: Refund): React.ReactNode => (
  <>
    <div className="mt-4">
      <InvoiceRefundStatusLozenge status={isEmpty(refund?.arn) ? 'PENDING' : 'REFUNDED'} />
      {refund?.type !== 'full-item-refund' && (
        <>{refund?.type && <span className="pl-8">{<InvoiceRefundCreditNote credittype={refund.type} />}</span>}</>
      )}
    </div>
  </>
);

export const getRefundIcon = (): JSX.Element => {
  // @ts-ignore
  return <img src={RefundIcon} height={'60px'} alt="invoice" />;
};

export const getRefundActions = (adaBaseUrl: string, billingDoc: BillingDoc) => {
  const { id } = billingDoc;
  return (
    <>
      {billingDoc?.sourceSystem === SourceSystem.HAMS && (
        <AdaRedirectButton href={getViewInAdaRefundUrl(adaBaseUrl, id)} />
      )}
    </>
  );
};

export const getRefundAdditionalDetails = (refund?: Refund, flag?: boolean) => {
  if (!refund) {
    return null;
  }

  return (
    <>
      <div className="billing-doc-dates">
        <h4>
          {refund?.sourceSystem === SourceSystem.HAMS && (
            <span>
              Refunded: {refund.refundedDate ? <FormattedDate date={refund.refundedDate} /> : 'Not available'}
            </span>
          )}
        </h4>
        <h4>
          {refund?.sourceSystem === SourceSystem.HAMS ? 'Invoice: ' : 'Issued: '}
          <span>
            <FormattedDate date={refund.createdDate} />
          </span>
        </h4>
        <h4>
          {refund?.sourceSystem === SourceSystem.CCP && (
            <div>PO Number: {refund?.purchaseOrderNumber ? refund?.purchaseOrderNumber : 'Not available'}</div>
          )}
          {flag && refund?.sourceSystem === SourceSystem.CCP && (
            <div>Transaction ID: {!isEmpty(refund?.arn) ? refund?.arn : 'Not available'}</div>
          )}
        </h4>
      </div>
    </>
  );
};

export const getRefundBreadcrumbTrail = (billingDoc: BillingDoc, organization?: Organization) => {
  const { id, orderId, domain } = billingDoc as Refund;
  const breadcrumbTrail: BreadcrumbItem.BreadcrumbItem[] = [];

  breadcrumbTrail.unshift({
    title: id,
    href: `${REFUND_PATH}/${encodeURIComponent(id)}`,
  });

  if (orderId) {
    breadcrumbTrail.unshift({
      title: orderId,
      href: `${INVOICE_PATH}/${encodeURIComponent(orderId)}`,
    });
  }

  if (domain) {
    breadcrumbTrail.unshift({
      title: domain,
      href: `${DOMAIN_PATH}/${encodeURIComponent(domain)}`,
    });
  }

  if (organization) {
    breadcrumbTrail.unshift({
      title: `${organization.organizationName}`,
      href: `${ORGANIZATION_PATH}/${encodeURIComponent(`${organization.organizationId}`)}`,
    });
  }

  return breadcrumbTrail;
};
